import { FiStar } from 'react-icons/fi';

const StarRating = ({ rating, size = 'sm', interactive = false, onChange }) => {
  const sizes = { xs: 12, sm: 14, md: 18, lg: 22, xl: 26 };
  const s = sizes[size] || 14;

  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= Math.round(rating);
        return (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(i)}
            className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform`}
          >
            <FiStar
              size={s}
              className={`transition-colors ${
                filled
                  ? 'fill-amber-400 text-amber-400'
                  : 'fill-none text-surface-300'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;